/**
 * useSelectedProperty — hook export extracted from SelectedPropertyContext.tsx.
 * Kept in a non-component .ts file so react-refresh/only-export-components
 * does not flag SelectedPropertyContext.tsx.
 */
import { useContext } from 'react';
import { SelectedPropertyContext } from '@/contexts/SelectedPropertyContext';

export function useSelectedProperty() {
  const ctx = useContext(SelectedPropertyContext);
  if (!ctx) throw new Error('useSelectedProperty must be used within SelectedPropertyProvider');
  return ctx;
}
